// src/pages/CancelRefund.js

import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ZaraAssistant from "../components/ZaraAssistant";
import { cancelReasons } from "../data/services";
import { useLanguage } from "../context/LanguageContext";
import translations from "../data/translations";
import useCancelSubscription from "../hooks/useCancelSubscription";

const CancelRefund = () => {
  const navigate = useNavigate();
  const { service, phone, network } = useLocation().state || {};
  const [reason, setReason] = useState("");
  const { submitCancel, submitting, error: apiError } = useCancelSubscription();
  const { language } = useLanguage();
  const t = translations[language] || translations["English"];

  const svc = service || {
    name: "Wallet Protection Plan", type: "Insurance",
    pricePerMonth: 99, totalDeducted: 297,
    maxCoverage: "Rs. 15,000", icon: "🛡️"
  };

  const handleSubmitCancel = async () => {
    if (!reason) {
      // hook khud bhi yeh check karta hai, lekin isay UI mein turant reflect karne ke liye
      // hum submitCancel ko call kar dete hain — woh apna error set kar dega.
    }
    try {
      const finalResponse = await submitCancel({ svc, phone, network, reason, language });
      navigate("/processing", { state: { service: svc, reason, phone, network, cancellationResponse: finalResponse } });
    } catch (err) {
      // apiError already set by the hook — UI neeche isko dikha dega
    }
  };

  return (
    <div className="container-fluid py-4 px-3 px-md-4" style={{ maxWidth: "900px", margin: "0 auto" }}>
      <Header showBack onBack={() => navigate(-1)} />

      <div className="card shadow-sm border-0 rounded-4 p-4 mb-4">

        {/* Step header */}
        <div className="d-flex align-items-center gap-3 mb-4">
          <div className="d-flex align-items-center justify-content-center rounded-circle text-white fw-bold flex-shrink-0"
            style={{ width: 42, height: 42, background: "#0099CC", fontSize: "1rem" }}>
            3
          </div>
          <div>
            <p style={{ fontWeight: 700, fontSize: "1rem", color: "#1a1a2e", marginBottom: "2px" }}>
              {t.cancelPageTitle}
            </p>
            <p style={{ fontSize: "0.78rem", color: "#888", marginBottom: 0 }}>
              {t.cancelPageSub}
            </p>
          </div>
        </div>

        {/* Service summary */}
        <div className="rounded-3 p-3 mb-4" style={{ border: "1.5px solid #e6eef3", background: "#fafcfe" }}>
          <div className="d-flex align-items-start gap-3">
            <div className="rounded-3 d-flex align-items-center justify-content-center flex-shrink-0"
              style={{ width: 48, height: 48, background: "#e8f6fb", fontSize: "1.4rem" }}>
              {svc.icon}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <p style={{ fontWeight: 700, fontSize: "0.9rem", color: "#1a1a2e", marginBottom: "3px" }}>{svc.name}</p>
              <p style={{ fontSize: "0.74rem", color: "#999", marginBottom: "2px" }}>
                {t.serviceType || "Service Type"}: {svc.type}
              </p>
              {svc.apiServiceLabel && (
                <p style={{ fontSize: "0.74rem", color: "#2c7fb8", marginBottom: "2px" }}>
                  Subscription Group: {svc.apiServiceLabel}
                </p>
              )}
              {svc.pricePerMonth != null && svc.pricePerMonth > 0 && (
                <p style={{ fontSize: "0.74rem", color: "#999", marginBottom: 0 }}>
                  {t.pricePlan || "Price Plan"}: Rs. {svc.pricePerMonth} / {t.month || "month"}
                </p>
              )}
            </div>
            <div style={{ textAlign: "right", flexShrink: 0 }}>
              {/* <p style={{ fontSize: "0.65rem", color: "#aaa", marginBottom: "2px" }}>{t.refundDeducted}</p>
              <p style={{ fontWeight: 700, fontSize: "0.9rem", color: "#1a1a2e", marginBottom: "8px" }}>
                Rs. {svc.totalDeducted}
              </p> */}
              {/* <p style={{ fontSize: "0.65rem", color: "#aaa", marginBottom: "2px" }}>{t.youCanGet}</p> */}
              {/* <p style={{ fontWeight: 700, fontSize: "0.82rem", color: "#27ae60", marginBottom: 0 }}>
                Up to {svc.maxCoverage}
              </p> */}
            </div>
          </div>
        </div>

        {/* Reason */}
        <p style={{ fontWeight: 600, fontSize: "0.88rem", color: "#1a1a2e", marginBottom: "12px" }}>
          {t.cancelReasonLabel}
        </p>
        <div className="row g-2 mb-4">
          {cancelReasons.map((r) => (
            <div key={r.id} className="col-12 col-md-6">
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "10px 12px",
                  borderRadius: "10px",
                  cursor: "pointer",
                  fontSize: "0.8rem",
                  lineHeight: 1.35,
                  background: reason === r.id ? "#e6f5fb" : "#fafafa",
                  border: `1.5px solid ${reason === r.id ? "#0099CC" : "#e6eef3"}`,
                  transition: "all 0.15s",
                }}
              >
                <input
                  type="radio"
                  name="reason"
                  value={r.id}
                  checked={reason === r.id}
                  onChange={() => setReason(r.id)}
                  style={{ accentColor: "#0099CC", flexShrink: 0 }}
                />

                {language === "English" ? r.labelEn : r.labelRu}
              </label>
            </div>
          ))}
        </div>

        {/* Info box */}
        <div className="rounded-3 p-3 mb-4" style={{ background: "#e6f5fb", border: "1px solid #b8dff0" }}>
          <div className="d-flex gap-2 align-items-start">
            <div className="d-flex align-items-center justify-content-center flex-shrink-0 text-white fw-bold rounded-circle"
              style={{ width: 24, height: 24, background: "#0099CC", fontSize: "0.7rem" }}>
              i
            </div>
            <p style={{ fontSize: "0.78rem", lineHeight: 1.6, color: "#2c5f7a", marginBottom: 0 }}>
              {t.cancelInfoText}
            </p>
          </div>
        </div>

        {/* Buttons */}
        {apiError && (
          <div style={{ background: "#fde2e2", color: "#9d1b1b", borderRadius: "12px", padding: "12px", marginBottom: "16px", fontSize: "0.88rem" }}>
            {apiError}
          </div>
        )}
        <button
          onClick={handleSubmitCancel}
          disabled={submitting}
          style={{
            width: "100%", padding: "13px",
            background: submitting ? "#77c4e8" : "#0099CC", color: "white",
            border: "none", borderRadius: "8px",
            fontSize: "1rem", fontWeight: 600,
            cursor: submitting ? "not-allowed" : "pointer", marginBottom: "10px",
            transition: "background 0.2s"
          }}
          onMouseEnter={e => { if (!submitting) e.currentTarget.style.background = "#007aaa"; }}
          onMouseLeave={e => { if (!submitting) e.currentTarget.style.background = "#0099CC"; }}
        >
          {submitting ? (t.cancelSubmitting || "Submitting...") : t.cancelConfirmBtn}
        </button>

        <button
          onClick={() => navigate(-1)}
          style={{
            width: "100%", padding: "13px",
            background: "white", color: "#0099CC",
            border: "1.5px solid #0099CC", borderRadius: "8px",
            fontSize: "1rem", fontWeight: 600,
            cursor: "pointer", marginBottom: "20px",
            transition: "background 0.2s"
          }}
          onMouseEnter={e => e.currentTarget.style.background = "#e6f5fb"}
          onMouseLeave={e => e.currentTarget.style.background = "white"}
        >
          {t.cancelBackBtn}
        </button>

        <ZaraAssistant
          message={t.ZARAMessage}
          features={t.ZARAFeatures || ["Quick & Easy", "Safe & Secure", "24/7 Support"]}
        />
      </div>

      <Footer />
    </div>
  );
};

export default CancelRefund;